<template>
    <div class="chinaMapDiv" :class="{ device_pixel_ratio: devicePixelRatio >= 1.5 }" v-loading="chinaMapLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div id="container" tabindex="0"></div>
        <div class="legendBox">
            <div><span>多</span>80-100</div>
            <div><span>中</span>70-80</div>
            <div><span>少</span>30-70</div>
            <div><span>低</span>0-30</div>
        </div>
    </div>
</template>
<script>
let _this = '';
import axios from 'axios';
import * as echarts from 'echarts';
import { cityMap, geoCoordMap, cityCoordMap, cityToPinyin } from '@/assets/js/mapJson.js';

const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
const remToPx = (rem) => rem * rootFontSize;
export default {
    name: 'ChinaMap',
    props: {
        msg: String,
        devicePixelRatio: {
            type: Number,
            default: 1
        },
        provinceDist: {
            type: Array,
            default: () => {
                return [];
            }
        },
        heatCityData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        provinceValData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        tooltipData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        chinaMapLoading: {
            type: Boolean,
            default: true
        },
        cityData: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            map: '',
            loca: '',
            checkedPoint: [], //点击选中的poi
            mapData: {},
            myChartMap: '',
            chinaMapChart: null,
            provinceCount: [],
            realTimeData: [], //实时行程
            cityCount: [],
            nowVehicleData: {},
            queryForm: {
                condition: { cityName: '中国' },
                pageNo: 1,
                pageSize: 20
            },
            cityRegionsData: [],
            heatParamMap: {
                '105%': { outerBlur: 25, innerBlur: 15, innerPoint: 15 },
                '110%': { outerBlur: 30, innerBlur: 20, innerPoint: 20 },
                '115%': { outerBlur: 35, innerBlur: 25, innerPoint: 25 },
                '130%': { outerBlur: 35, innerBlur: 25, innerPoint: 25 },
                '140%': { outerBlur: 45, innerBlur: 35, innerPoint: 35 }
            },
            mapOption: null,
            mapHandleEvents: null,
            resizeHandler: null // 新增：存储resize事件处理函数，用于后续销毁
        };
    },
    mounted() {
        _this = this;
        this.role = localStorage.getItem('role');
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));

        this.initChartsMap();
        // 关键修改1：绑定窗口resize事件，添加防抖动
        this.resizeHandler = this.debounce(() => {
            this.handleResize();
        }, 0);
        window.addEventListener('resize', this.resizeHandler);
    },
    // 关键修改2：组件销毁前移除事件监听，避免内存泄漏
    beforeUnmount() {
        window.removeEventListener('resize', this.resizeHandler);
        if (this.myChartMap) {
            this.myChartMap.dispose();
            this.myChartMap = null;
        }
    },
    watch: {
        heatCityData: {
            handler(val) {
                this.chinaMapChart && this.setHeatCityData(val);
            },
            immediate: true
        },
        cityData: {
            handler(val) {
                if (val && val.areaName) {
                    setTimeout(() => {
                        let cityName = val.areaName;
                        axios.get(cityMap[cityName]).then((res) => {
                            echarts.registerMap(cityName, res.data);
                            _this.mapHandleEvents.resetOption(_this.chinaMapChart, _this.mapOption, cityName);
                            _this.setHeatCityData(_this.heatCityData);
                        });
                    }, 500);
                }
            },
            immediate: true
        }
    },
    methods: {
        // 关键修改3：新增防抖动函数，减少resize触发频率
        debounce(func, delay) {
            let timer = null;
            return function () {
                clearTimeout(timer);
                timer = setTimeout(() => {
                    func.apply(this, arguments);
                }, delay);
            };
        },
        setHeatCityData(data) {
            const updatedData = this.processHeatmapData(data);
            const option = this.chinaMapChart.getOption();
            option.series[0].data = updatedData; // 外围光晕
            option.series[1].data = updatedData; // 中心消除
            this.chinaMapChart.setOption(option);
        },
        getHeatParams() {
            const currentLayout = this.getLayoutSize();
            return this.heatParamMap[currentLayout] || this.heatParamMap['140%'];
        },
        setCityNameColor(activeFlag) {
            this.chinaMapChart.setOption({
                label: activeFlag
                    ? {
                          show: true,
                          color: '#fff',
                          rich: { transparent: { color: 'transparent' } },
                          formatter: function (params) {
                              if (params.name === '黑龙江省') {
                                  return '{transparent|' + params.name + '}';
                              }
                              return params.name;
                          }
                      }
                    : { show: true, color: '#fff', formatter: '{a}' }
            });
        },
        linkVehicleMap(row) {
            if (this.userInfo.batchId || this.role == 0) {
                return false;
            }
            let routeUrl = this.$router.resolve({
                path: '/vehicleMap',
                query: { deviceNumber: row.deviceNumber, startTime: row.tripStartTime, endTime: row.tripEndTime }
            });
            window.open(routeUrl.href, '_blank');
        },
        split_array(arr, len) {
            let a_len = arr.length;
            let result = [];
            for (let i = 0; i < a_len; i += len) {
                result.push(arr.slice(i, i + len));
            }
            return result;
        },
        createMap(id, opt) {
            let _this = this;

            echarts.extendsMap = function (id, opt) {
                _this.chinaMapChart = echarts.init(document.getElementById(id), null, { renderer: 'svg' });
                let provinceData = [];
                let curGeoJson = {};
                let levelColorMap = {
                    1: 'rgba(241, 109, 115, .8)',
                    2: 'rgba(255, 235, 59, .7)',
                    3: 'rgba(147, 235, 248, 1)'
                };

                let defaultOpt = {
                    mapName: 'china',
                    goDown: true,
                    bgColor: '#404a59',
                    activeArea: [],
                    data: [],
                    callback: function (name, option, instance) {}
                };
                if (opt) {
                    opt = echarts.util.extend(defaultOpt, opt);
                }

                let name = [opt.mapName];
                let idx = 0;

                let pos = { leftPlus: 115, leftCur: 150, left: 198, top: 240 };
                let line = [
                    [0, 0],
                    [8, 11],
                    [0, 22]
                ];
                let style = {
                    font: '18px "Microsoft YaHei", sans-serif',
                    textColor: '#30FBFE',
                    lineColor: '#30FBFE'
                };

                let handleEvents = {
                    resetOption: function (i, o, n) {
                        if (n === 'china') {
                            option.series[1].data = handleEvents.initSeriesData(_this.cityCount).slice(1, 5);
                            option.series[2].data = handleEvents.initSeriesData(_this.cityCount).slice(0, 1);
                        }
                        let breadcrumb = this.createBreadcrumb(n);
                        let j = name.indexOf(n);
                        let l = o.graphic.length;

                        if (j < 0) {
                            o.graphic.push(breadcrumb);
                            o.graphic[0].children[0].shape.x2 = 145;
                            o.graphic[0].children[1].shape.x2 = 145;
                            if (o.graphic.length > 2) {
                                let cityData = [];
                                let cityJson;
                                for (let x = 0; x < opt.data.length; x++) {
                                    let tmpIndex = opt.data[x].parent.indexOf('省');
                                    let tmpName = tmpIndex != -1 ? opt.data[x].parent.slice(0, tmpIndex) : null;
                                    opt.data[x].parent = tmpName ? tmpName : opt.data[x].parent;

                                    if (n === opt.data[x].parent) {
                                        let optData = [opt.data[x]];
                                        cityJson = {
                                            name: optData[0].name,
                                            value: optData[0].value,
                                            tripsNum: optData[0].tripsNum,
                                            totalMileage: optData[0].totalMileage,
                                            totalDuration: optData[0].totalDuration,
                                            parent: n
                                        };
                                        cityData.push(cityJson);
                                    }
                                }
                                o.series[0].data = cityData ? handleEvents.initSeriesData(cityData) : [];
                            }
                            name.push(n);
                            idx++;
                        } else {
                            o.graphic.splice(j + 2, l);
                            if (o.graphic.length <= 2) {
                                o.graphic[0].children[0].shape.x2 = 60;
                                o.graphic[0].children[1].shape.x2 = 60;
                                o.series[0].data = handleEvents.initSeriesData(opt.data);
                            }
                            name.splice(j + 1, l);
                            idx = j;
                            pos.leftCur -= pos.leftPlus * (l - j - 1);
                        }
                        o.geo.map = n;
                        o.geo.zoom = 0.4;
                        o.geo.layoutCenter = n == 'china' ? ['50%', '50%'] : ['50%', '50%'];
                        i.clear();
                        i.setOption(o);
                        this.zoomAnimation(n);
                        opt.callback(n, o, i);
                    },
                    createBreadcrumb: function (name) {
                        let breadcrumb = {
                            type: 'group',
                            id: name,
                            left: '49%',
                            z: 999,
                            top: pos.top + 3,
                            children: [
                                {
                                    type: 'polyline',
                                    left: -90,
                                    top: -5,
                                    z: 999,
                                    shape: { points: line },
                                    style: { stroke: '#30FBFE', key: name },
                                    onclick: function () {
                                        let name = this.style.key;
                                        handleEvents.resetOption(chart, option, name);
                                    }
                                },
                                {
                                    type: 'text',
                                    left: -68,
                                    z: 999,
                                    top: 'middle',
                                    style: {
                                        text: name,
                                        textAlign: 'center',
                                        fill: style.textColor,
                                        font: style.font
                                    },
                                    onclick: function () {
                                        let name = this.style.text;
                                        handleEvents.resetOption(chart, option, name);
                                    }
                                },
                                {
                                    type: 'text',
                                    left: -68,
                                    z: 999,
                                    top: 10,
                                    style: {
                                        name: name,
                                        text: cityToPinyin[name] ? cityToPinyin[name].toUpperCase() : '',
                                        textAlign: 'center',
                                        fill: style.textColor,
                                        font: '12px "Microsoft YaHei", sans-serif'
                                    },
                                    onclick: function () {
                                        let name = this.style.name;
                                        handleEvents.resetOption(chart, option, name);
                                    }
                                }
                            ]
                        };
                        pos.leftCur += pos.leftPlus;
                    },
                    initSeriesData: function (data) {
                        let temp = [];
                        let tmpCityCoordMap = _this.cityData.areaName ? geoCoordMap : cityCoordMap;

                        for (let i = 0; i < data.length; i++) {
                            let geoCoord = tmpCityCoordMap[data[i].name];
                            if (geoCoord) {
                                temp.push({
                                    name: data[i].name,
                                    value: geoCoord.concat(data[i].value),
                                    num: data[i].value,
                                    totalMileage: data[i].totalMileage,
                                    totalDuration: data[i].totalDuration,
                                    tripsNum: data[i].tripsNum,
                                    region: data[i].region
                                });
                            }
                        }
                        return temp;
                    },
                    zoomAnimation: function (n) {
                        let count = null;
                        let _zoom = n == '中国' ? 1 : 0.6;
                        let zoom = function (per) {
                            if (!count) count = per;
                            count = count + per;

                            _this.chinaMapChart.setOption({
                                geo: { zoom: count, label: { zlevel: 2 }, zlevel: 1 }
                            });

                            if (count < _zoom)
                                window.requestAnimationFrame(function () {
                                    zoom(0.2);
                                });
                        };
                        window.requestAnimationFrame(function () {
                            zoom(0.2);
                        });
                    }
                };

                let option = {
                    tooltip: { show: true },
                    visualMap: {
                        min: 0,
                        max: 100,
                        calculable: true,
                        orient: 'vertical',
                        right: '-100',
                        bottom: '150',
                        inRange: { color: ['blue', 'cyan', 'lime', 'yellow', 'red'] },
                        textStyle: { color: '#fff' }
                    },
                    graphic: [
                        {
                            type: 'group',
                            left: '45%',
                            top: pos.top - 4,
                            children: [
                                {
                                    type: 'line',
                                    left: 0,
                                    z: 999,
                                    top: -20,
                                    shape: { x1: 0, y1: 0, x2: 60, y2: 0 },
                                    style: { stroke: 'transparent' }
                                },
                                {
                                    type: 'line',
                                    z: 999,
                                    left: 0,
                                    top: 20,
                                    shape: { x1: 0, y1: 0, x2: 60, y2: 0 },
                                    style: { stroke: 'transparent' }
                                }
                            ]
                        },
                        {
                            id: name[idx],
                            type: 'group',
                            left: '46%',
                            z: 999,
                            top: pos.top,
                            children: [
                                {
                                    type: 'polyline',
                                    left: 90,
                                    top: -12,
                                    z: 999,
                                    shape: { points: line },
                                    style: { stroke: 'transparent', key: name[0] },
                                    onclick: function () {
                                        let name = this.style.key;
                                        handleEvents.resetOption(_this.chinaMapChart, option, name);
                                    }
                                }
                            ]
                        }
                    ],
                    geo: {
                        map: opt.mapName,
                        roam: false,
                        layoutCenter: ['50%', '65%'],
                        layoutSize: _this.getLayoutSize(),
                        zoom: 1,
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 5,
                        tooltip: {
                            show: true,
                            trigger: 'item',
                            backgroundColor: 'rgba(8, 15, 61, 0.8)',
                            borderColor: '#00E0FF',
                            borderWidth: 1,
                            textStyle: { color: '#fff', fontSize: 12 },
                            hideDelay: 100,
                            enterable: true,
                            formatter: function (params, ticket, callback) {
                                if (params.componentType == 'geo' && _this.provinceValData[params.name]) {
                                    return `
                                            城市：${params.name}<br/>
                                            ${_this.tooltipData.label}：${_this.provinceValData[params.name].totalHeatMapDataVal || 0}${_this.tooltipData.unit}<br/>
                                        `;
                                }
                            }
                        },
                        label: {
                            show: true,
                            color: '#fff',
                            fontSize: remToPx(0.14),
                            avoidLabelOverlap: true,
                            formatter: function (params) {
                                if (params.name === '香港特别行政区') {
                                    return '      香港';
                                } else if (params.name === '澳门特别行政区') {
                                    return '澳门    ';
                                }
                                return params.name;
                            },
                            zlevel: 2
                        },
                        itemStyle: {
                            borderColor: '#0795F3',
                            borderWidth: 1,
                            opacity: 1,
                            areaColor: 'transparent'
                        },
                        emphasis: {
                            itemStyle: { areaColor: 'transparent', borderWidth: 1 },
                            label: { color: '#fff' }
                        },
                        zlevel: 1
                    },
                    series: [
                        {
                            name: '外围光晕',
                            type: 'heatmap',
                            coordinateSystem: 'geo',
                            data: _this.heatCityData.length > 0 ? _this.processHeatmapData(opt.data, _this.heatCityData) : [],
                            pointSize: 0,
                            blurSize: _this.getHeatParams().outerBlur,
                            // zlevel: 1,
                            opacity: 0.6,
                            gradient: {
                                0: 'rgba(255, 255, 255, 0)',
                                0.2: 'rgba(255, 200, 200, 0.1)',
                                0.5: 'rgba(255, 100, 100, 0.4)',
                                1: 'rgba(200, 0, 0, 0.6)'
                            }
                        },
                        {
                            name: '中心消除',
                            type: 'heatmap',
                            coordinateSystem: 'geo',
                            data: _this.heatCityData.length > 0 ? _this.processHeatmapData(opt.data, _this.heatCityData) : [],
                            pointSize: _this.getHeatParams().innerPoint,
                            blurSize: _this.getHeatParams().innerBlur,
                            // zlevel: 1,
                            opacity: 0.8,
                            gradient: {
                                0: 'rgba(255, 255, 255, 1)',
                                0.5: 'rgba(255, 255, 255, 0.8)',
                                1: 'rgba(255, 255, 255, 0)'
                            }
                        }
                    ]
                };
                _this.mapOption = option;
                _this.mapHandleEvents = handleEvents;

                _this.chinaMapChart.setOption(option);
                _this.chinaMapChart.on('click', function (params) {
                    let _name = name[idx] == 'china' ? '中国' : name[idx];
                    let _self = this;
                    if (opt.goDown && params.name !== _name) {
                        if (cityMap[params.name]) {
                            let url = cityMap[params.name];
                            axios.get(url).then((res) => {
                                curGeoJson = res.data;
                                echarts.registerMap(params.name, curGeoJson);
                                handleEvents.resetOption(_self, option, params.name);
                            });
                        }
                    }
                });

                _this.chinaMapChart.setMap = function (mapName) {
                    let _self = this;
                    if (mapName.indexOf('市') < 0) mapName = mapName + '市';
                    let citySource = cityMap[mapName];
                    if (citySource) {
                        let url = citySource;
                        axios.get(url).then((res) => {
                            curGeoJson = res.data;
                            echarts.registerMap(mapName, curGeoJson);
                            handleEvents.resetOption(_self, option, mapName);
                        });
                    }
                };

                return _this.chinaMapChart;
            };

            _this.myChartMap = echarts.extendsMap(id, opt);
            this.handleResize();
        },
        processHeatmapData(heatData) {
            let tmpCityData = [];

            for (const key in heatData) {
                tmpCityData.push({ name: key, value: 1, heatMapVal: heatData[key] });
            }

            let tmpData = this.mapHandleEvents.initSeriesData(tmpCityData);

            if (Object.keys(heatData).length > 0) {
                tmpData.forEach((item) => {
                    for (const key in heatData) {
                        if (item.name.indexOf(key) !== -1) {
                            item.value[2] = heatData[key];
                        }
                    }
                });
            }

            return tmpData;
        },
        // 原有handleResize方法（逻辑不变，确保geo尺寸同步）
        handleResize() {
            setTimeout(() => {
                const newLayoutSize = this.getLayoutSize();
                this.myChartMap.setOption({
                    geo: { layoutSize: newLayoutSize, label: { zlevel: 2 }, zlevel: 1 }
                });

                const heatParams = this.getHeatParams();
                this.myChartMap.setOption({
                    series: [
                        { name: '外围光晕', blurSize: heatParams.outerBlur },
                        { name: '中心消除', blurSize: heatParams.innerBlur, pointSize: heatParams.innerPoint }
                    ]
                });

                this.myChartMap.resize();
            }, 300);
        },
        initChartsMap() {
            let _this = this;
            axios.get('/map/data-china1.json').then((res) => {
                echarts.registerMap('china', res.data);

                if (res.data && res.data.features && Array.isArray(res.data.features)) {
                    const regions = res.data.features.map((feature) => {
                        return feature.properties.name || '未知区域';
                    });
                    _this.cityRegionsData = [...new Set(regions)];
                } else {
                    console.error('地图数据格式不正确，无法提取区域名称');
                }

                if (_this.chinaMapChart) {
                    _this.chinaMapChart.dispose();
                }
                _this.createMap('container', {
                    bgColor: 'transparent',
                    mapName: 'china',
                    goDown: true,
                    callback: function (name, option, instance) {},
                    data: _this.cityCount
                });
            });
        },
        getMapOption() {
            return {
                geo: {
                    map: 'china',
                    layoutSize: this.getLayoutSize(),
                    roam: false,
                    itemStyle: { areaColor: '#fff', borderColor: '#ccc' },
                    label: { zlevel: 2 },
                    zlevel: 1
                }
            };
        },
        getLayoutSize() {
            const windowWidth = window.innerWidth;
            const sizeMap = [
                { width: 1303, size: '105%' },
                { width: 1610, size: '110%' },
                { width: 1646, size: '115%' },
                { width: 1710, size: '130%' },
                { width: 1790, size: '140%' }
            ];

            let targetSize = '130%';
            for (let i = 0; i < sizeMap.length; i++) {
                if (windowWidth <= sizeMap[i].width) {
                    targetSize = sizeMap[i].size;
                    break;
                }
            }

            return targetSize;
        },
        appendScript(url) {
            let jsapi = document.createElement('script');
            jsapi.charset = 'utf-8';
            jsapi.src = url;
            document.head.appendChild(jsapi);
        }
    }
};
</script>
<style lang="less" scoped>
.chinaMapDiv {
    position: relative;
    width: 100%;
    height: 100%;
    background: url(../../public/images/home/map1.png) no-repeat;
    background-size: cover;
    #container {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .legendBox {
        position: absolute;
        bottom: 20px;
        left: 20px;
        div {
            display: inline-block;
            margin-right: 30px;
            position: relative;
            padding-left: 10px;
            font-size: 0.16rem;
            span {
                margin-right: 10px;
                color: #889fb3;
            }
        }
        div::before {
            content: '';
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: red;
            margin-right: 5px;
            position: absolute;
            left: -5px;
            top: 52%;
            transform: translateY(-50%);
        }
        div:nth-child(2)::before {
            background: #fefe00;
        }
        div:nth-child(3)::before {
            background: #34ff00;
        }
        div:nth-child(4)::before {
            background: #0051ff;
        }
    }
}
.slide_title {
    font-size: 0.18rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
}
.slide_carousel {
    width: 100%;
    height: 0.88rem;
    margin-top: 0.12rem;
}
.route_list li,
.hint_text p {
    width: 2.38rem;
    min-width: 170px;
    height: 0.38rem;
    line-height: 0.38rem;
    background: rgba(54, 153, 255, 0.2);
    text-align: center;
    font-size: 0.16rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #30fbfe;
    margin-bottom: 0.12rem;
    cursor: pointer;
    padding: 0 0.15rem;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
}
.route_list span {
    /* width: 1.1rem;
		overflow:hidden;
		text-overflow:ellipsis;
		-o-text-overflow:ellipsis;
		white-space:nowrap; */
}
.route_list b {
    /* width: 1.28rem;
		overflow:hidden;
		text-overflow:ellipsis;
		-o-text-overflow:ellipsis;
		white-space:nowrap; */
}
.hint_text p {
    margin-top: 0.12rem;
    margin-bottom: 0;
    justify-content: center;
}
.route_list li.active {
    margin-bottom: 0;
}
</style>